module.exports = __webpack_public_path__ + "56773f6227a7d6a6cee3b79e75d247ae.png";